export default {
  nav: {
    home: 'الرئيسية',
    categories: 'التصنيفات',
    cart: 'سلة التسوق',
    orders: 'الطلبات',
    wishlist: 'المفضلة',
    vendor: 'البائع',
    notifications: 'الإشعارات',
    profile: 'الملف الشخصي',
    addresses: 'العناوين',
    paymentMethods: 'طرق الدفع',
    security: 'الأمان',
    settings: 'الإعدادات',
    storyEditor: 'محرر القصص',
    more: 'المزيد',
    closeMenu: 'إغلاق القائمة',
    language: 'اللغة',
    help: 'المساعدة والدعم',
  },
  header: {
    welcome: 'مرحباً',
    searchPlaceholder: 'البحث في المنتجات والماركات والتصنيفات...',
    searchMobile: 'بحث...',
    search: 'بحث',
    delivery: 'توصيل',
    pickup: 'استلام',
    selectAddress: 'اختيار العنوان',
    selectLocation: 'تحديد الموقع',
    schedule: 'الجدولة',
    setAddress: 'تحديد العنوان',
    inStorePickup: 'استلام من المتجر',
    notifications: 'الإشعارات',
    customer: 'عميل',
    guest: 'زائر',
    address: 'العنوان',
    scheduledSelected: 'تم تحديد التوصيل المجدول',
    courierSelected: 'تم تحديد توصيل البريد',
    pickupSelected: 'تم تحديد الاستلام من المتجر',
    searchingFor: 'أبحث عن',
  },
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    add: 'إضافة',
    confirm: 'تأكيد',
    back: 'رجوع',
    backToProfile: 'العودة للملف الشخصي',
    next: 'التالي',
    close: 'إغلاق',
    loading: 'جارٍ التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    empty: 'فارغ',
    seeAll: 'عرض الكل',
    appName: 'بازارك',
    appNameEn: 'Bazaarak',
    currency: 'دولار',
    viewAll: 'عرض الكل',
    items: 'عنصر',
    store: 'المتجر',
    clear: 'مسح',
    enabled: 'مفعّل',
    disabled: 'معطّل',
    enable: 'تفعيل',
  },
  auth: {
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    phone: 'رقم الهاتف',
    forgotPassword: 'نسيت كلمة المرور',
    signInRequired: 'يلزم تسجيل الدخول',
    addressSignInPrompt: 'يرجى تسجيل الدخول لإدارة عناوين التوصيل',
    unauthorized: 'انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.',
    signIn: 'دخول',
    signUp: 'تسجيل',
    createAccount: 'إنشاء حساب',
    welcomeBack: 'أهلاً بعودتك!',
    createYourAccount: 'أنشئ حسابك',
    customer: 'عميل',
    vendor: 'بائع',
    name: 'الاسم',
    fullName: 'الاسم الكامل',
    storeName: 'اسم المتجر',
    confirmPassword: 'تأكيد كلمة المرور',
    enterYourName: 'أدخل اسمك',
    emailOrUsername: 'البريد / اسم المستخدم',
    enterEmailOrUsername: 'أدخل بريدك أو اسم المستخدم',
    enterYourPassword: 'أدخل كلمة المرور',
    confirmYourPassword: 'أكد كلمة المرور',
    enterStoreName: 'أدخل اسم المتجر',
    enterPhoneNumber: '+966 50 123 4567',
    rememberMe: 'تذكرني',
    orContinueWith: 'أو تابع باستخدام',
    continueWithGoogle: 'المتابعة مع غوغل',
    continueWithApple: 'المتابعة مع آبل',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب بالفعل؟',
    backToHome: 'العودة للرئيسية',
    signingIn: 'جارٍ تسجيل الدخول...',
    creatingAccount: 'جارٍ إنشاء الحساب...',
    verifiedVendor: 'بائع موثق',
  },
  product: {
    addToCart: 'أضف للسلة',
    addToWishlist: 'أضف للمفضلة',
    buyNow: 'اشتري الآن',
    outOfStock: 'غير متوفر',
    discount: 'خصم',
    price: 'السعر',
    originalPrice: 'السعر الأصلي',
    reviews: 'تقييم',
    description: 'الوصف',
    related: 'منتجات مشابهة',
    inStock: 'متوفر',
    quantity: 'الكمية',
    availability: 'التوفر',
    selectVariant: 'اختيار النموذج',
    save: 'وفر',
    notFound: 'المنتج غير موجود',
    notFoundDesc: 'هذا المنتج غير موجود أو تمت إزالته.',
    browseProducts: 'تصفح المنتجات',
    home: 'الرئيسية',
    addingToCart: 'جارٍ الإضافة...',
    addingToWishlist: 'جارٍ الإضافة...',
    addedToCart: 'تمت الإضافة للسلة!',
    addedToWishlist: 'تمت الإضافة للمفضلة!',
    failedToLoad: 'فشل تحميل المنتج',
    failedToAddCart: 'فشل الإضافة للسلة',
    failedToAddWishlist: 'فشل الإضافة للمفضلة',
    viewCart: 'عرض السلة',
    products: 'منتجات',
    nSellers: '{{count}} بائع',
    fromPrice: 'من',
    priceRange: 'من €{{from}} إلى €{{to}}',
    chooseStore: 'اختر متجراً',
    soldBySelected: 'يتم البيع بواسطة المتجر المحدد',
    availableAtStores: 'متوفر في {{count}} متجرًا',
    store: 'متجر',
    multipleVariants: '{{count}} خيارات',
  },
  cart: {
    title: 'سلة التسوق',
    empty: 'سلة التسوق فارغة',
    emptyDesc: 'ابدأ التسوق لإضافة منتجات إلى سلة التسوق',
    total: 'الإجمالي',
    checkout: 'المتابعة للدفع',
    continueShopping: 'مواصلة التسوق',
    orderSummary: 'ملخص الطلب',
    subtotal: 'المجموع الفرعي',
    shipping: 'الشحن',
    tax: 'الضريبة (19٪)',
    discount: 'الخصم',
    couponCode: 'كود الخصم',
    enterCode: 'أدخل الكود',
    apply: 'تطبيق',
    couponApplied: 'تم تطبيق الخصم (10٪)',
    free: 'مجاناً',
    processing: 'جارٍ المعالجة...',
    secureCheckout: 'دفع آمن عبر Stripe',
    signIn: 'يرجى تسجيل الدخول',
    signInDesc: 'سجل دخولك لعرض سلة التسوق',
    itemsInCart: 'عنصر في السلة',
    each: 'لكل',
  },
  categories: {
    browse: 'تصفح التصنيفات',
    explore: 'استكشف مجموعتنا الواسعة عبر جميع التصنيفات',
    all: 'كل التصنيفات',
    electronics: 'إلكترونيات',
    fashion: 'أزياء وملابس',
    home: 'منزل وحديقة',
    sports: 'رياضة ونشاطات خارجية',
    books: 'كتب ووسائط',
    beauty: 'جمال وصحة',
    toys: 'ألعاب وألعاب ترفيهية',
    automotive: 'سيارات',
    jewelry: 'مجوهرات وساعات',
    pet: 'مستلزمات الحيوانات',
    office: 'مستلزمات مكتبية',
    productsAvailable: 'منتج متوفر',
    subcategories: 'التصنيفات الفرعية',
    noProductsFound: 'لا توجد منتجات لـ',
    products: 'منتجات',
  },
  home: {
    browseByCategory: 'تسوق حسب التصنيف',
    browseCategoryDesc: 'استكشف مجموعة واسعة من التصنيفات المتميزة',
    featuredProducts: 'منتجات مميزة',
    featuredDesc: 'عناصر مختارة خصيصاً لك',
    nearYouProducts: 'بالقرب منك الآن',
    nearYouDesc: 'مختارة حسب منطقتك والوقت المحلي',
    topProducts: 'منتجات مميزة',
    topProductsDesc: 'الأكثر مبيعاً هذا الأسبوع',
    sold: 'تم البيع',
    youMightLike: 'قد يعجبك',
    youMightLikeDesc: 'منتجات مختارة من متاجرك المفضلة',
    trendingNow: 'الأكثر رواجاً',
    trendingDesc: 'ابقَ متقدماً مع أحدث الصيحات',
    premiumMarketplace: 'سوق متميز',
    heroTitle1: 'اكتشف',
    heroTitle2: 'منتجات متميزة',
    heroDesc: 'جرب التسوق الفاخر مع مجموعتنا المختارة من الماركات المتميزة والمنتجات الحصرية. رحلتك نحو التميز تبدأ من هنا.',
    exploreNow: 'استكشف الآن',
    becomeVendor: 'كن بائعاً',
    products: 'منتج',
    vendors: 'بائع',
    happyCustomers: 'عميل سعيد',
    deliverTo: 'التوصيل إلى',
    selectAddress: 'اختيار العنوان',
    schedule: 'الجدولة',
    selectDateTime: 'اختيار التاريخ والوقت',
    popularSearches: 'عمليات البحث الشائعة',
    shopNow: 'تسوق الآن',
    explore: 'استكشف',
    summerCollection: 'مجموعة صيف 2024',
    summerDesc: 'اكتشف أحدث صيحات هذا الموسم',
    smartHome: 'أساسيات المنزل الذكي',
    smartHomeDesc: 'حوّل مساحة معيشتك',
    wellness: 'العافية والعناية الذاتية',
    wellnessDesc: 'منتجات متميزة لرفاهيتك',
    fashion: 'أزياء',
    tech: 'تقنية',
    beauty: 'جمال',
    selectDeliveryAddress: 'اختيار عنوان التوصيل',
    scheduleDelivery: 'جدولة التوصيل',
    addNewAddress: 'إضافة عنوان جديد',
    selectDate: 'اختيار التاريخ',
    selectTimeSlot: 'اختيار الفترة الزمنية',
    confirmSchedule: 'تأكيد الجدولة',
    topVendors: 'أفضل المتاجر',
    topVendorsDesc: 'متاجر موثوقة بالقرب منك',
    topRatedNearYou: 'الأعلى تقييماً بالقرب منك',
    discoverWhatYouLike: 'اكتشف ما يعجبك',
    sponsored: 'حمایت‌شده',
    filter: {
      'all': 'الكل',
      'wishlist': 'المفضلة',
      'on-sale': 'تخفيض',
      'free-shipping': 'توصيل مجاني',
      'new-arrivals': 'وصل حديثاً',
      'best-seller': 'الأكثر مبيعاً',
      'top-rated': 'الأعلى تقييماً',
      'price-drop': 'انخفاض السعر',
      'express': 'سريع',
      'premium': 'متميز',
    },
    topStores: 'أفضل المتاجر',
    since: 'منذ',
  },
  orders: {
    title: 'طلباتي',
    totalOrders: 'إجمالي الطلبات',
    noOrders: 'لا توجد طلبات',
    noOrdersDesc: 'ابدأ التسوق لمشاهدة طلباتك هنا!',
    signIn: 'يرجى تسجيل الدخول',
    signInDesc: 'سجل دخولك لعرض طلباتك',
    all: 'الكل',
    processing: 'قيد المعالجة',
    shipped: 'تم الشحن',
    delivered: 'تم التوصيل',
    cancelled: 'ملغى',
    orderedOn: 'تم الطلب في',
    estDelivery: 'التوصيل المتوقع:',
    viewDetails: 'عرض التفاصيل',
    hideDetails: 'إخفاء التفاصيل',
    track: 'تتبع',
    orderItems: 'عناصر الطلب',
    priceDetails: 'تفاصيل السعر',
    shippingAddress: 'عنوان الشحن',
    tracking: 'رقم التتبع:',
    subtotal: 'المجموع الفرعي',
    shipping: 'الشحن',
    tax: 'الضريبة (19٪)',
    total: 'الإجمالي',
    item: 'عنصر',
    items: 'عناصر',
    qty: 'الكمية:',
  },
  profile: {
    title: 'الملف الشخصي',
    backToHome: 'العودة للرئيسية',
    editProfile: 'تعديل الملف الشخصي',
    saveChanges: 'حفظ التغييرات',
    memberSince: 'عضو منذ',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    myOrders: 'طلباتي',
    viewAllPurchases: 'عرض كل المشتريات',
    savedItems: 'عنصر محفوظ',
    manageLocations: 'إدارة المواقع',
    savedCards: 'بطاقات محفوظة',
    preferences: 'التفضيلات',
    passwordAnd2FA: 'كلمة المرور والمصادقة الثنائية',
    language: 'اللغة',
    helpSupport: 'دعم على مدار الساعة',
    logout: 'تسجيل الخروج',
    confirmLogout: 'تأكيد الخروج',
    confirmLogoutDesc: 'هل أنت متأكد من رغبتك في تسجيل الخروج من حسابك؟',
    uploadProfilePicture: 'رفع صورة الملف الشخصي',
    clickToUpload: 'انقر للرفع أو اسحب وأفلت',
    chooseFile: 'اختيار ملف',
    version: 'بازارك الإصدار 1.0.0',
    terms: 'الشروط',
    privacy: 'الخصوصية',
    backToProfile: 'العودة للملف الشخصي',
    welcomeBack: 'مرحباً بعودتك، {{name}}',
    yourPoints: 'نقاطك',
    yourLevel: 'مستواك',
    levelBronze: 'برونزي',
    levelSilver: 'فضي',
    levelGold: 'ذهبي',
    levelDiamond: 'ماسي',
    levelLegend: 'أسطوري',
    pointsToNext: 'تحتاج {{count}} نقطة إضافية للمستوى التالي',
    maxLevel: 'وصلت إلى أعلى مستوى',
    memberOfSince: 'عضو بازارك منذ {{date}}',
    proTitle: 'بازارك برو',
    proDesc: 'تجربة أكثر فخامة مع مزايا خاصة',
    proUpgrade: 'الترقية إلى برو',
    proExtend: 'تمديد برو',
    proActive: 'نشط',
    proActivated: 'تم تفعيل عضوية برو',
    proActiveUntil: 'نشط حتى {{date}}',
    proBenefitShipping: 'شحن مجاني',
    proBenefitDiscounts: 'خصومات حصرية',
    proBenefitSupport: 'دعم مميز',
    proBenefitReturns: 'إرجاع مجاني',
    proComingSoon: 'عضوية برو قريباً',
    inviteTitle: 'ادعُ الأصدقاء',
    inviteDesc: 'ادعُ أصدقاءك واحصل على نقاط وجوائز',
    inviteCode: 'رمز الدعوة',
    inviteCta: 'ادعُ واكسب نقاطاً',
    inviteCopied: 'تم نسخ رمز الدعوة',
    enterInviteCode: 'أدخل رمز الدعوة',
    applyInvite: 'تطبيق الرمز',
    referralApplied: 'تم تطبيق مكافأة الدعوة',
    referralBonusHint: 'أنت وصديقك تحصلان على {{count}} نقطة لكل منكما',
    shareInviteText: 'انضم إلي في بازارك! رمز الدعوة: {{code}}',
    orderAll: 'كل الطلبات',
    orderProcessing: 'قيد المعالجة',
    orderShipped: 'تم الشحن',
    orderDelivered: 'تم التسليم',
    orderReturns: 'المرتجعات',
    accountInfo: 'معلومات الحساب',
    giftCards: 'بطاقات الهدايا',
    giftCardsSoon: 'بطاقات الهدايا قريباً',
    supportHelp: 'الدعم والمساعدة',
    settings: 'الإعدادات',
    levelPlatinum: 'بلاتينيوم',
    pullForMemberPass: 'اسحب للأسفل — بطاقة المهرجان',
    pullToHidePass: 'اسحب للأعلى لإخفاء البطاقة',
    memberPassEyebrow: 'نادي الأعضاء',
    memberPassTitle: 'Bazaarak — Bringing Home Closer',
    memberPassSubtitle: 'مستوى {{level}} يفتح مزايا المهرجانات',
    yourQrCode: 'رمز QR الخاص بك',
    scanToInvite: 'يمكن للأصدقاء مسح هذا الرمز للانضمام بدعوتك',
    festivalPerksTitle: 'مزايا المهرجان لديك',
    festivalPerkAccess: 'الوصول لقسم المهرجان',
    festivalPerkDiscount: 'خصومات خاصة بالمهرجان',
    festivalPerkGift: 'هدايا وتغليف مميز',
    festivalPerkPoints: 'نقاط مضاعفة في المهرجان',
    festivalPerkVip: 'دخول VIP للفعاليات',
    festivalPerkEarly: 'وصول مبكر للعروض',
  },
  wishlist: {
    title: 'مفضلتي',
    saved: 'محفوظ',
    totalValue: 'القيمة الإجمالية',
    potentialSavings: 'توفير محتمل',
    inStock: 'متوفر',
    addToCart: 'أضف للسلة',
    addAllToCart: 'أضف الكل للسلة',
    shareWishlist: 'مشاركة المفضلة',
    empty: 'مفضلتك فارغة',
    emptyDesc: 'ابدأ بإضافة المنتجات التي تحبها إلى مفضلتك',
    startShopping: 'بدء التسوق',
    signIn: 'يرجى تسجيل الدخول',
    signInDesc: 'سجل دخولك لعرض مفضلتك',
    removedFromWishlist: 'تمت الإزالة من المفضلة',
    backToProfile: 'العودة للملف الشخصي',
    failedToLoad: 'فشل تحميل المفضلة',
  },
  vendor: {
    dashboard: 'لوحة تحكم البائع',
    manageDashboard: 'أدر متجرك وتابع الأداء',
    editStore: 'تعديل المتجر',
    addProduct: 'إضافة منتج',
    createStory: 'إنشاء قصة',
    overview: 'نظرة عامة',
    overviewTab: 'نظرة عامة',
    productsTab: 'منتجات',
    storiesTab: 'قصص',
    analyticsTab: 'تحليلات',
    totalSales: 'إجمالي المبيعات',
    orders: 'طلبات',
    products: 'منتجات',
    customers: 'عملاء',
    recentOrders: 'الطلبات الأخيرة',
    viewAll: 'عرض الكل',
    inventoryAlerts: 'تنبيهات المخزون',
    manageInventory: 'إدارة المخزون',
    myStories: 'قصصي',
    stories: 'قصة',
    editStoreInfo: 'تعديل معلومات المتجر',
    addNewProduct: 'إضافة منتج جديد',
    editProduct: 'تعديل منتج',
    createNewStory: 'إنشاء قصة جديدة',
    editStory: 'تعديل قصة',
    stripeAlertTitle: 'حساب Stripe غير متصل',
    stripeAlertDesc: 'لتحقيق الإيرادات من مبيعات المنتجات، قم بتوصيل حساب Stripe أولاً. بدونه لا يمكن إضافة منتجات.',
    stripeConnectBtn: 'ربط حساب Stripe',
    stripeConnecting: 'جارٍ الربط...',
    stripeNoEmail: 'لم يتم تعيين بريد المتجر الإلكتروني. يرجى إدخال بريد إلكتروني في إعدادات المتجر أولاً.',
    stripeConnectFailed: 'فشل الربط بـ Stripe. يرجى المحاولة مرة أخرى.',
    stripeStatusTitle: 'حالة Stripe',
    stripeNotConnected: 'حساب Stripe غير متصل',
    stripeActive: 'نشط',
    stripeInactive: 'غير نشط',
    stripeCanSell: 'يمكنك بيع المنتجات',
    stripeCannotSell: 'لا يمكنك بيع المنتجات بعد',
    stripeAccountId: 'معرف الحساب',
    stripeContinueOnboarding: 'متابعة Onboarding',
    stripeResetBtn: 'إعادة تعيين Stripe',
    stripeResetTitle: 'إعادة تعيين حساب Stripe',
    stripeResetDesc: 'هل أنت متأكد؟ سيؤدي ذلك إلى إزالة حساب Stripe الخاص بك وستحتاج إلى الاتصال مرة أخرى.',
    stripeResetConfirm: 'نعم، إعادة تعيين',
    stripeResetting: 'جارٍ إعادة التعيين...',
    stripeResetFailed: 'فشل إعادة تعيين حساب Stripe',
    stripeProductsBlockTitle: 'ربط Stripe لإضافة منتجات',
    stripeProductsBlockDesc: 'متجرك غير متصل بـ Stripe بعد. أكمل الربط من لوحة التحكم الرئيسية أولاً.',
    stripeBlockTitle: 'مطلوب ربط Stripe',
    stripeBlockDesc: 'لإضافة منتجات وتحقيق إيرادات، يجب ربط حساب Stripe الخاص بك أولاً.',
    fillRequired: 'يرجى ملء جميع الحقول المطلوبة',
    saveFailed: 'فشل حفظ المنتج',
    deleteFailed: 'فشل حذف المنتج',
    storeNameLabel: 'اسم المتجر',
    storeDescLabel: 'وصف المتجر',
    ordersEmpty: 'لا توجد طلبات بعد',
    salesLabel: 'مبيعات',
    stockLeft: 'متبقي',
    lowStock: 'مخزون منخفض',
    revenueLabel: 'الإيرادات',
    categoryLabel: 'التصنيف',
    orderLabel: 'طلب',
    itemsLabel: 'عناصر',
    guestCustomer: 'زائر',
    noProductsYet: 'لا توجد منتجات بعد',
    addProductDesc: 'أضف أول منتج لك لبدء البيع',
    productNameLabel: 'اسم المنتج',
    productNamePlaceholder: 'أدخل اسم المنتج',
    otherCategory: 'أخرى',
    productDescPlaceholder: 'أدخل وصف المنتج...',
    productImageLabel: 'صورة المنتج',
    uploading: 'جارٍ الرفع...',
    uploadImage: 'رفع صورة',
    deleteProductTitle: 'حذف المنتج؟',
    deleteProductDesc: 'هل أنت متأكد من رغبتك في الحذف',
    noProducts: 'لا توجد منتجات بعد',
    uploadNetworkError: 'رفع الصور عبر الخادم غير متاح. يرجى إدخال رابط الصورة.',
    useImageUrl: 'رابط الصورة',
    hideUrl: 'إغلاق الرابط',
    imageUrlHint: 'إذا لم يعمل رفع الصورة، أدخل رابط الصورة المباشر:',
    imageUrlPlaceholder: '/uploads/example.jpg',
    applyUrl: 'تطبيق',
  },
  notifications: {
    title: 'الإشعارات',
    unread: 'غير مقروء',
    markAllRead: 'تحديد الكل كمقروء',
    allNotifications: 'الكل',
    unreadNotifications: 'غير مقروء',
    noNotifications: 'لا توجد إشعارات',
    noNotificationsDesc: 'أنت على اطلاع! عد لاحقاً للتحديثات.',
    markRead: 'تحديد كمقروء',
  },
  addresses: {
    title: 'عناويني',
    yourAddresses: 'عناوينك',
    saved: 'محفوظ',
    location: 'موقع',
    locations: 'مواقع',
    addNew: 'إضافة جديد',
    noAddresses: 'لا توجد عناوين بعد',
    noAddressesDesc: 'أضف عنوان التوصيل الأول للبدء',
    addAddress: 'إضافة عنوان',
    signIn: 'يرجى تسجيل الدخول',
    signInDesc: 'سجل دخولك لإدارة عناوينك',
    addNewAddress: 'إضافة عنوان جديد',
    editAddress: 'تعديل العنوان',
    deleteAddress: 'حذف العنوان؟',
    deleteAddressDesc: 'هل أنت متأكد من رغبتك في الحذف',
    cannotBeUndone: 'لا يمكن التراجع عن هذا الإجراء.',
    setDefault: 'تعيين كافتراضي',
    backToProfile: 'العودة للملف الشخصي',
    default: 'افتراضي',
    searchTab: 'بحث',
    savedTab: 'محفوظ',
    resultsFound: 'نتيجة',
    startTypingHint: 'ابدأ بكتابة عنوانك...',
    editPin: 'تعديل الدبوس',
    locationType: 'نوع الموقع',
    apartment: 'شقة',
    house: 'منزل',
    office: 'مكتب',
    doorbellName: 'الاسم على الجرس',
    doorbellNamePlaceholder: 'مثال: "أحمد علي"',
    entrance: 'المدخل',
    entrancePlaceholder: 'مثال: "مدخل B"',
    additionalInfo: 'معلومات إضافية للساعي',
    additionalInfoPlaceholder: 'تعليمات للساعي...',
    addressRequired: 'يرجى اختيار عنوان',
    phoneRequired: 'رقم الهاتف مطلوب',
  },
  payment: {
    title: 'طرق الدفع',
    saved: 'محفوظ',
    method: 'طريقة',
    methods: 'طرق',
    addNew: 'إضافة جديد',
    noPaymentMethods: 'لا توجد طرق دفع بعد',
    noPaymentMethodsDesc: 'أضف طريقة الدفع الأولى للبدء',
    addPaymentMethod: 'إضافة طريقة دفع',
    savePaymentMethod: 'حفظ طريقة الدفع',
    addPaymentMethodTitle: 'إضافة طريقة دفع',
    setDefault: 'تعيين كافتراضي',
    default: 'افتراضي',
    deletePaymentMethod: 'حذف طريقة الدفع؟',
    deleteDesc: 'هل أنت متأكد من رغبتك في حذف هذه الطريقة؟ لا يمكن التراجع عن هذا الإجراء.',
    backToProfile: 'العودة للملف الشخصي',
    card: 'بطاقة',
    paypal: 'PayPal',
    bank: 'بنك',
    cardNumber: 'رقم البطاقة',
    cardHolder: 'اسم حامل البطاقة',
    expiryDate: 'تاريخ الانتهاء',
    cvv: 'CVV',
    cardType: 'نوع البطاقة',
    paypalEmail: 'بريد PayPal',
    bankName: 'اسم البنك',
    accountNumber: 'رقم الحساب',
    setAsDefault: 'تعيين كطريقة دفع افتراضية',
    cardHolder_placeholder: 'الاسم الكامل على البطاقة',
    editPaymentMethod: 'تعديل طريقة الدفع',
    saveChanges: 'حفظ التغييرات',
    expires: 'تنتهي',
    cardHolderLabel: 'حامل البطاقة',
  },
  security: {
    title: 'إعدادات الأمان',
    manageDesc: 'أدر أمان حسابك',
    changePassword: 'تغيير كلمة المرور',
    changePasswordDesc: 'حدّث كلمة مرور حسابك',
    twoFA: 'المصادقة الثنائية',
    biometric: 'الدخول البيومتري',
    activeSessions: 'الجلسات النشطة',
    loginHistory: 'سجل الدخول',
    viewRecentActivity: 'عرض النشاط الأخير',
    deleteAccount: 'حذف الحساب',
    deleteDesc: 'إزالة الحساب نهائياً',
    recentLoginActivity: 'النشاط الأخير للدخول',
    enable2FA: 'تفعيل المصادقة الثنائية',
    disable2FA: 'إلغاء المصادقة الثنائية',
    sessions: 'أجهزة نشطة',
    enable2FATitle: 'تفعيل المصادقة الثنائية',
    disable2FATitle: 'إلغاء المصادقة الثنائية',
    enable2FADesc: 'أضف طبقة أمان إضافية لحسابك بالمصادقة الثنائية.',
    disable2FADesc: 'سيكون حسابك أقل أماناً بدون حماية المصادقة الثنائية.',
    activeSessionsTitle: 'الجلسات النشطة',
    updatePassword: 'تحديث كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    enterCurrentPassword: 'أدخل كلمة المرور الحالية',
    enterNewPassword: 'أدخل كلمة المرور الجديدة',
    confirmNewPassword: 'أكد كلمة المرور الجديدة',
    passwordsDoNotMatch: 'كلمتا المرور غير متطابقتين!',
    passwordMinLength: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل!',
    scanQRCode: 'مسح رمز QR',
    useAuthenticator: 'استخدم Google Authenticator أو تطبيقاً مشابهاً',
    success: 'نجاح',
    failed: 'فشل',
    backToProfile: 'العودة للملف الشخصي',
    current: 'الحالي',
    logout: 'خروج',
    deleteAccountTitle: 'حذف الحساب',
    deleteAccountDesc: 'لا يمكن التراجع عن هذا الإجراء. سيتم حذف جميع بياناتك نهائياً.',
    deleteWarning: '• سيتم حذف جميع الطلبات وسجل المشتريات\n• ستُزال العناوين وطرق الدفع المحفوظة\n• ستُفقد عناصر قائمة الأمنيات\n• هذا الإجراء لا يمكن التراجع عنه',
  },
  help: {
    title: 'المساعدة والدعم',
    subtitle: 'نحن هنا لمساعدتك على مدار الساعة',
    liveChat: 'دردشة مباشرة',
    liveChatDesc: 'دردش مع فريق الدعم',
    available247: 'متاح 24/7',
    emailSupport: 'دعم البريد الإلكتروني',
    emailSupportDesc: 'support@bazarak.com',
    responseTime: 'رد خلال 24 ساعة',
    phoneSupport: 'دعم هاتفي',
    phoneSupportDesc: '+966 50 123 4567',
    monFri: 'الأحد - الخميس، 9 ص - 6 م',
    whatsapp: 'واتساب',
    whatsappDesc: 'راسلنا على واتساب',
    faq: 'الأسئلة الشائعة',
    allTopics: 'كل المواضيع',
    orders: 'طلبات',
    payments: 'مدفوعات',
    shipping: 'شحن',
    returns: 'إرجاع',
    account: 'حساب',
    quickLinks: 'روابط سريعة',
    terms: 'شروط الخدمة',
    privacy: 'سياسة الخصوصية',
    refund: 'سياسة الاسترداد',
    shippingPolicy: 'سياسة الشحن',
    stillNeedHelp: 'هل تحتاج مساعدة؟',
    stillNeedHelpDesc: 'لم تجد ما تبحث عنه؟ فريق الدعم جاهز لمساعدتك.',
    contactSupport: 'تواصل مع الدعم',
    contactSupportTitle: 'تواصل مع الدعم',
    yourName: 'اسمك',
    emailAddress: 'عنوان البريد الإلكتروني',
    subject: 'الموضوع',
    message: 'الرسالة',
    sendMessage: 'إرسال الرسالة',
    noFaqFound: 'لا توجد أسئلة في هذا التصنيف',
    startChat: 'بدء الدردشة',
    sendEmail: 'إرسال بريد',
    callNow: 'اتصال',
    openWhatsApp: 'فتح واتساب',
    backToProfile: 'العودة للملف الشخصي',
    subjectPlaceholder: 'بماذا يمكننا مساعدتك؟',
    messagePlaceholder: 'يرجى وصف مشكلتك بالتفصيل...',
    namePlaceholder: 'أدخل اسمك',
  },
  footer: {
    quickLinks: 'روابط سريعة',
    support: 'الدعم',
    downloadApp: 'تحميل التطبيق',
    description: 'بازارك، متجر إلكتروني للمنتجات الطازجة والعالية الجودة. ضمان أفضل الأسعار وأسرع توصيل.',
    rights: '© 2026 بازارك. جميع الحقوق محفوظة.',
    contactUs: 'تواصل معنا',
    terms: 'شروط الاستخدام',
    privacy: 'سياسة الخصوصية',
    helpCenter: 'مركز المساعدة',
    appStore: 'App Store',
    googlePlay: 'Google Play',
  },
  language: {
    title: 'اللغة',
    persian: 'الفارسية',
    english: 'الإنجليزية',
    german: 'الألمانية',
    turkish: 'التركية',
    arabic: 'العربية',
    selectLanguage: 'اختيار اللغة',
    currentLanguage: 'اللغة الحالية',
    availableLanguages: 'اللغات المتاحة',
    changeInfo: 'سيؤدي تغيير اللغة إلى تحديث واجهة التطبيق بالكامل فوراً.',
    switchConfirm: 'التبديل إلى {{name}} ({{native}})؟',
  },
  datetime: {
    title: 'جدولة التوصيل',
    quickSelect: 'الاختيار السريع',
    selectDate: 'اختيار التاريخ',
    selectTime: 'اختيار الوقت',
    today: 'اليوم',
    tomorrow: 'غداً',
    dayAfter: 'بعد غد',
    nextWeek: 'الأسبوع القادم',
    su: 'أح',
    mo: 'إث',
    tu: 'ثل',
    we: 'أر',
    th: 'خم',
    fr: 'جم',
    sa: 'سب',
    deliveryTo: 'التوصيل إلى',
    pickupFrom: 'الاستلام من',
    courierArrives: 'سيصل الساعي خلال هذه الفترة',
    readyForPickup: 'سيكون طلبك جاهزاً للاستلام',
    confirmSchedule: 'تأكيد الجدولة',
    selectDateTime: 'اختيار التاريخ والوقت',
  },
  bazaarHub: {
    title: 'بازارك',
    subtitle: 'كل شيء في مكان واحد',
    categories: 'التصنيفات',
    search: 'بحث',
    cart: 'السلة',
    orders: 'الطلبات',
    profile: 'الملف الشخصي',
    wishlist: 'المفضلة',
    offers: 'العروض',
    vendors: 'البائعون',
    addresses: 'العناوين',
    notifications: 'الإشعارات',
    settings: 'الإعدادات',
    help: 'المساعدة',
  },
  theme: {
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
  },
  search: {
    productLabel: 'المنتجات',
    categoryLabel: 'التصنيفات',
    wishlistLabel: 'المفضلة',
    offerLabel: 'العروض',
    addressLabel: 'العناوين',
    vendorLabel: 'البائعون',
    for: 'لـ',
    filteringBy: 'الفلترة حسب',
    clearCategoryFilter: 'مسح فلتر التصنيف',
    relevance: 'الأكثر صلة',
    priceLowToHigh: 'السعر: من الأقل',
    priceHighToLow: 'السعر: من الأعلى',
    newest: 'الأحدث',
    topRated: 'الأعلى تقييماً',
    allPrices: 'جميع الأسعار',
    allRatings: 'جميع التقييمات',
    sortBy: 'الترتيب حسب',
    priceRange: 'نطاق السعر',
    rating: 'التقييم',
    filters: 'الفلاتر',
    applyFilters: 'تطبيق الفلاتر',
    clearAllFilters: 'مسح كل الفلاتر',
    brand: 'العلامة التجارية',
    color: 'اللون',
    size: 'الحجم',
    allBrands: 'جميع العلامات التجارية',
    allColors: 'جميع الألوان',
    allSizes: 'جميع الأحجام',
    noBrands: 'لا توجد علامات تجارية',
    noColors: 'لا توجد ألوان',
    noSizes: 'لا توجد أحجام',
    typeToFind: 'اكتب للبحث عن منتجات، تصنيفات، وأكثر',
    resultsFor: 'نتائج البحث عن',
    resultsFound: 'نتيجة',
    items: 'المنتجات',
    stores: 'المتاجر',
    categories: 'التصنيفات',
    itemFound: 'منتج',
    storeFound: 'متجر',
    categoryFound: 'تصنيف',
    tryDifferentKeywords: 'جرب كلمات مختلفة',
    noProductsFound: 'لا توجد منتجات',
    noStoresFound: 'لا توجد متاجر',
    noCategoriesFound: 'لا توجد تصنيفات',
  },
  aiAssistant: {
    title: 'المساعد الذكي',
    subtitle: 'كيف يمكنني مساعدتك؟',
    hotDeals: 'صفقات ساخنة',
    trackOrder: 'تتبع الطلب',
    popular: 'الأكثر شعبية',
    findStores: 'العثور على المتاجر',
    comingSoon: 'الميزات الذكية قريباً!',
    askAnything: 'اسأل أي شيء...',
    errorReply: 'عذراً، حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  },
  stores: {
    title: 'جميع المتاجر',
    stores: 'متجر',
    searchPlaceholder: 'البحث في المتاجر بالاسم أو المدينة أو الوسم...',
    sortPopular: 'الأكثر شعبية',
    sortRating: 'الأعلى تقييماً',
    sortNewest: 'الأحدث',
    sortProducts: 'الأكثر منتجات',
    endOfList: 'نهاية القائمة',
  },
  errors: {
    loadFailed: 'فشل تحميل البيانات. يرجى المحاولة مرة أخرى.',
    noResults: 'لم يتم العثور على نتائج',
  },
  admin: {
    title: 'لوحة الإدارة',
    menu: 'القائمة',
    backToSite: 'العودة للموقع',
    dashboard: 'لوحة التحكم',
    users: 'المستخدمون',
    stores: 'المتاجر',
    products: 'المنتجات',
    orders: 'الطلبات',
    categories: 'التصنيفات',
    search: 'البحث في هذا القسم...',
    totalUsers: 'إجمالي المستخدمين',
    totalStores: 'إجمالي المتاجر',
    totalProducts: 'إجمالي المنتجات',
    totalOrders: 'إجمالي الطلبات',
    totalRevenue: 'إجمالي الإيرادات',
    pendingOrders: 'الطلبات المعلقة',
    quickActions: 'إجراءات سريعة',
    addCategory: 'إضافة تصنيف',
    addProduct: 'إضافة منتج',
    viewOrders: 'عرض الطلبات',
    manageUsers: 'إدارة المستخدمين',
    name: 'الاسم',
    email: 'البريد',
    role: 'الدور',
    joined: 'تاريخ الانضمام',
    storeName: 'اسم المتجر',
    address: 'العنوان',
    rating: 'التقييم',
    products: 'المنتجات',
    productName: 'اسم المنتج',
    price: 'السعر',
    stock: 'المخزون',
    status: 'الحالة',
    orderId: 'رقم الطلب',
    customer: 'العميل',
    total: 'الإجمالي',
    date: 'التاريخ',
    categoryName: 'اسم التصنيف',
    parentCategory: 'التصنيف الأب',
    mainCategory: 'تصنيف رئيسي',
    noneTopLevel: 'بدون (المستوى الأعلى)',
    sortOrder: 'الترتيب',
    confirmDelete: 'تأكيد الحذف',
    confirmDeleteDesc: 'هل أنت متأكد من رغبتك في حذف هذا العنصر؟ لا يمكن التراجع عن هذا الإجراء.',
    edit: 'تعديل',
    canAddProducts: 'السماح بإضافة المنتجات',
  },
};